
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  putSupplierDeduction,
  getClaimReason,
  getDeductionMethod,
  giveDeductionInfo,
  checkProductDeduction
} from "@/api/credit-note";
import Pagination from "@/components/Pagination/index.vue";
import { getSuppliersList } from "@/api/inquiry";

import {
  auditHold,
  removeQuotation,
  generatePI,
  auditPass,
} from "@/api/inquiry";
import {
  confirmOrder,
  invalidPi,
  uncancelPi,
  getDetailHeader,
  getPurchaseOrderDetail,
  uploadInfoFile,
  deleteFile,
} from "@/api/proforma";
import {
  downloadPoDetail,
  downloadTemplate,
  downloadTemplateExcel,
  getAppendix,
  putMakeUnderdelivery,
  poDetailShippingRemark,
  poDetailRemark,
  updateCompanyDiscountPrice, updateCompanyPriceRemark
} from "@/api/purchase-order";
import { cal } from "@/utils/cal";
import { formatPrice } from "@/utils/number";
import {clearPurchaseOrderClaimInfo} from "@/api/claim-form";
import checkPermission from "@/utils/permission_btn";
import { UserModule } from "@/store/modules/user";

@Component({
  name: "PurchaseOrderDetails",
  components: {
    Pagination,
    PoDetailsHeader: () => import("./components/PoDetailsHeader.vue"),
    ClaimAmountDeduction: () =>
      import("./components/claim-amount-deduction/index.vue"),
    MarkUnderissued: () => import("./components/mark-underissued/index.vue"),
    EditContractualDelivery: () =>
      import("./components/edit-contractual-delivery/index.vue"),
  },
})
export default class extends Vue {
  private tableLoading = false;
  private tableMaxHeight = 400;
  private id = "";
  private supplierId = "";
  private showActions = true;
  private isShowMore = false;
  private isShowMore2 = false;
  private isShowMore3 = false;
  private listLoading = true;
  private showCreate = false;
  private showMark = false;
  private showContractualDelivery = false;
  private contractualDeliveryItem: any = null;
  private showReceipt = false;
  private showFile = false;
  private otherFeeVisible = false;
  private otherFeeDetailVisible = false;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [
      {
        id: "123",
      },
    ] as any[],
  };
  private otherFeeTable = {
    list: [] as any[],
    info: {} as any,
  }
  private otherFeeDetailTable = {
    list: [] as any[],
  }
  private overDeliveryIcon = require("@/assets/images/ic_chaofa.png");
  private underDeliveryIcon = require("@/assets/images/ic_qianfa.png");
  private customerSampleIcon = require("@/assets/images/ic_customer_sample.png");
  private supplierSampleIcon = require("@/assets/images/ic_supplier_sample.png");
  private sampleIcon = require("@/assets/images/ic_sample.png");
  private showRemarkDialog = false;
  private remarkText = "";
  private remarkLength = 50;
  private remarkRow: any = null;
  private remarkHandler = "handleRemark";
  private numberColumns: Array<{ label: string; prop: string }> = [];
  public info = {} as any;
  public uploadDocLoading = false;
  public listParam = {
    numberKeyword: "",
    hqProductName: "",
  };
  private deliveryStatusOptions: Array<{ label: string; value: string }> = [];

  get visibleNumberColumns() {
    return this.isShowMore3 ? this.numberColumns : [];
  }

  get showCompanyDiscountPrice() {
    const buttonCodes = (this.$route.meta as any)?.buttonCodes;
    return (
      this.matchAccount(["B", "A_B"]) &&
      checkPermission(["updateCompanyPrice"], buttonCodes)
    );
  }

  get showCompanyPriceRemark() {
    return this.matchAccount(["B", "A_B"]);
  }

  private supplierList = [
    {
      label: "供应商",
      prop: "supplierId",
      key: "supplierId",
      type: "select",
      placeholder: "请选择供应商",
      clearable: true,
      rules: {
        required: true,
        message: "请选择供应商",
        trigger: "change",
      },
      remote_method: this.getSuppliersList,
      remote: true,
      options: [],
      labelKey: "abbreviation",
      valueKey: "id",
    },
    {
      label: "扣款类型",
      prop: "claimReason",
      key: "claimReason",
      type: "cascader",
      options: [],
      placeholder: "请选择扣款类型",
      clearable: true,
      rules: {
        required: true,
        message: "请选择扣款类型",
        trigger: "change",
      },
    },
    {
      label: "交易公司",
      prop: "company",
      key: "company",
      type: "select",
      labelKey: "desc",
      valueKey: "name",
      options: [
        {
          desc: "华强",
          name: "HQ",
        },
        {
          desc: "嘉锐",
          name: "JR",
        },
      ],
      placeholder: "请选择交易公司",
      clearable: true,
      rules: {
        required: true,
        message: "请选择交易公司",
        trigger: "change",
      },
    },
    {
      label: "扣款金额",
      prop: "claimAmount",
      key: "claimAmount",
      type: "inputNumber",
      placeholder: "请输入扣款金额",
      clearable: true,
      rules: {
        required: true,
        message: "请输入扣款金额",
        trigger: "change",
      },
    },
    {
      label: "协议号码",
      prop: "protocolNumber",
      key: "protocolNumber",
      type: "input",
      placeholder: "请输入协议号码",
      clearable: true,
    },
    {
      label: "对应开票金额",
      prop: "invoicingAmount",
      key: "invoicingAmount",
      type: "input",
      placeholder: "请输入对应开票金额",
      clearable: true,
    },
    {
      label: "扣款比例",
      prop: "deductionRatio",
      key: "deductionRatio",
      type: "input",
      placeholder: "请输入扣款比例",
      clearable: true,
      maxlength: 10,
      unit: "%",
    },
    {
      label: "签约日期",
      prop: "timeOfIssue",
      key: "timeOfIssue",
      type: "datetime",
      format: "yyyy-MM-dd hh:mm:ss",
      placeholder: "请选择签约日期",
      clearable: true,
    },
    {
      label: "抵扣方式",
      prop: "deductionMethod",
      key: "deductionMethod",
      type: "select",
      options: [],
      placeholder: "请选择抵扣方式",
      clearable: true,
      labelKey: "desc",
      valueKey: "name",
      rules: {
        required: true,
        message: "请选择抵扣方式",
        trigger: "change",
      },
    },
    {
      label: "扣款说明",
      prop: "remark",
      key: "remark",
      type: "textarea",
      placeholder: "请输入扣款说明",
      clearable: true,
    },
  ];
  private supplierForm = {
    supplierId: "",
    claimReason: "",
    company: "",
    claimAmount: 0,
    protocolNumber: "",
    invoicingAmount: "",
    deductionRatio: "",
    timeOfIssue: "",
    deductionMethod: "",
    remark: "",
  };
  private showCreateSupplierDeduction = false;
  private deductionInfo = {
    unDeductedClaims: 0,
    reserveDeduction: 0,
    toDeductedAmount: 0,
    unDeductedAmount: 0,
    purchaseOrderDeductionAmount: 0
  }

  private deductionClaimInfo: any;

  public isReUpload:Boolean = false;
  public isReUploadId = '' as any;

  created() {
    if (this.$route.params.id) {
      this.id = (this.$route.params.id as string) || "";
      this.supplierId = (this.$route.params.supplierId as string) || "";
    } else {
      this.id = (this.$route.query.id as string) || "";
      this.supplierId = (this.$route.query.supplierId as string) || "";
    }
    this.init();
    this.getAppendix();
  }

  mounted() {
    this.updateTableMaxHeight();
    window.addEventListener("resize", this.updateTableMaxHeight);
  }

  activated() {
    this.init();
    this.$nextTick(() => {
      this.updateTableMaxHeight();
    });
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.updateTableMaxHeight);
  }

  private updateTableMaxHeight() {
    this.$nextTick(() => {
      const wrap = this.$refs.tableWrap as HTMLElement;
      if (!wrap) {
        return;
      }
      const height = wrap.clientHeight;
      this.tableMaxHeight = height > 200 ? height : 200;
      this.layoutTable();
    });
  }

  private layoutTable() {
    this.$nextTick(() => {
      const table = this.$refs.table as any;
      if (table && table.doLayout) {
        table.doLayout();
      }
    });
  }

  private matchAccount(accounts: string[]) {
    const userAccounts = UserModule.accountType || [];
    return userAccounts.some((account) => accounts.includes(account));
  }

  private receivedQuantity(row: any) {
    return parseInt(row.goodsEnteredQuantity) + parseInt(row.declarationPlanQuantity);
  }

  private isDeliveryIncomplete(row: any) {
    const received = this.receivedQuantity(row);
    const ordered = Number(row.orderQuantity);
    return !Number.isNaN(received) && !Number.isNaN(ordered) && received < ordered;
  }

  private displayCell(value: any) {
    if (value === 0) {
      return 0;
    }
    if (value === "null" || value === "undefined") {
      return "";
    }
    return value || "";
  }

  private priceText(value: any) {
    if (value === "" || value == null || value === "null" || value === "undefined") {
      return "";
    }
    const amount = Number(value);
    if (Number.isNaN(amount)) {
      return this.displayCell(value);
    }
    const formatted = formatPrice(amount);
    if (!formatted) {
      return "";
    }
    const negative = formatted.startsWith("-");
    const unsigned = negative ? formatted.slice(1) : formatted;
    const parts = unsigned.split(".");
    const grouped = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const body = parts.length > 1 ? `${grouped}.${parts[1]}` : grouped;
    return negative ? `-${body}` : body;
  }

  private hasPurchaseBreakdown(row: any) {
    return row.purchaseUnitPrice != null || row.purchaseDiscount != null;
  }

  private openRemark(row: any, handler: string, length = 50, prop = "remark") {
    this.remarkRow = row;
    this.remarkText = prop !== "remark" ? row[prop] : row.remark;
    this.remarkLength = length;
    this.remarkHandler = handler;
    this.showRemarkDialog = true;
  }

  private confirmRemark() {
    const payload = {
      ...this.remarkRow,
      remark: this.remarkText,
    };
    const handler = this.remarkHandler;
    this.showRemarkDialog = false;
    this.remarkText = "";
    this.remarkHandler = "handleRemark";
    (this as any)[handler](payload);
  }

  private clearTableSelection() {
    const table = this.$refs.table as any;
    if (table && table.clearSelection) {
      table.clearSelection();
    }
  }

  private init() {
    this.getDetailHeader();
    this.getSuppliersList();
    this.getList();
    this.getClaimReason();
    this.getDeductionMethod();
  }

  private async getAppendix() {
    let params = {
      receipt: true,
    };
    const res: any = await getAppendix(this.id, params);
    if (res.appendixList.length > 0) {
      this.isReUpload = true;
      this.isReUploadId = res.appendixList[0].id;
    } else {
      this.isReUpload = false;
    }
  }

  private async Underdevelopment() {
    if (this.selectedRows.length === 0) {
      this.$notify({
        title: "提示",
        message: "请至少选择一行数据",
        type: "warning",
        duration: 2000,
      });
      return;
    }
    this.$confirm("确定标记欠发吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
    .then(async () => {
      let data = this.selectedRows.map(item => {
        return item.id
      })
      await putMakeUnderdelivery(data).then(res => {
        this.$notify({
          title: "提示",
          message: "操作成功",
          type: "success",
          duration: 2000
        });
        this.clearTableSelection();
        this.getList();
      }).catch(err => {
        console.log(err)
      })
    })
    .catch((err) => {
      console.error(err);
    });
  }

  private async getClaimReason() {
    const res: any = await getClaimReason();
    this.supplierList[1].options = res;
  }

  private async getDeductionMethod() {
    const res: any = await getDeductionMethod();
    this.supplierList[8].options = res;
  }

  private async getDetailHeader() {
    const res: any = await getDetailHeader(this.id);
    this.info = res;
    this.supplierId = res.supplierId;
    this.updateTableMaxHeight();
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.supplierList[0].options = res;
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    this.tableLoading = true;
    await getPurchaseOrderDetail(this.id, params).then(res => {
      const { total, list }: any = res
      this.table.total = +total;
      if (list.length > 0 && list[0].models) {
        list[0].models.forEach((model, index) => {
          const prop = "num" + index;
          if (this.numberColumns.findIndex((column) => column.prop === prop) === -1) {
            this.numberColumns.unshift({
              label: model.typeName,
              prop,
            });
          }
        });
      }
      if (list.length > 0) {
        list.forEach((item) => {
          if (item.models && item.models.length > 0) {
            item.models.forEach((model, num) => {
              item[`num${num}`] = model.number;
            });
          }
          item.deliveryProgress = `${(parseInt(item.goodsEnteredQuantity) + parseInt(item.declarationPlanQuantity))}/${item.orderQuantity}`;
        });
      }
      this.table.list = list;
      this.tableLoading = false;
      this.updateTableMaxHeight();
    }).catch(err => {
      console.log(err)
      this.tableLoading = false;
    });
    this.loading = false;
  }
  // 自动计算
  private async handleCalculate(item) {
    const purchaseDiscount = +item.purchaseDiscount;
    const purchaseDiscountUnitPrice = +cal.cheng(
      +cal.jian(1, purchaseDiscount),
      +item.purchaseUnitPrice
    );
    this.$set(
      item,
      "purchaseDiscountUnitPrice",
      purchaseDiscountUnitPrice || 0
    );
    // 获取采购总价
    const purchaseTotalPrice = +cal.cheng(
      purchaseDiscountUnitPrice,
      item.orderQuantity || 0
    );
    this.$set(item, "purchaseTotalPrice", purchaseTotalPrice);
  }

  private async handleExport() {
    await downloadPoDetail(this.id).then((res: any) => {
      // this.createFile(res, "采购订单详情" + Date.now() + ".xlsx");
    });
  }
  private async downloadTemplate() {
    await downloadTemplate(this.id);
  }

  private async downloadTemplateExcel() {
    await downloadTemplateExcel(this.id);
  }

  private async submitForm() {
    this.showCreate = false;
    this.selectedRows = [];
    this.clearTableSelection();
    this.getList();
  }

  private createFile(res: any, fileName: string) {
    let blob = new Blob([res.data]);
    let downloadElement = document.createElement("a");
    let href = window.URL.createObjectURL(blob); //创建下载的链接
    downloadElement.href = href;
    downloadElement.download = fileName; //下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); //点击下载
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  }

  private purchaseOrderInfoIdsOfSP = [] as any;
  // 创建供应商扣款
  public async handleCreate() {
    if (this.selectedRows.length === 0) {
      this.$notify({
        title: "提示",
        message: "请至少选择一行数据",
        type: "error",
        duration: 2000,
      });
      return;
    }
    let purchaseOrderInfoIds = this.selectedRows.map((item) => {
      return item.id;
    });
    await checkProductDeduction(purchaseOrderInfoIds)
    .then(async () => {
      this.purchaseOrderInfoIdsOfSP = purchaseOrderInfoIds;
      let data = {
        supplierId: this.supplierId,
        purchaseOrderId: this.id,
        purchaseOrderInfoIds
      }
      const res: any = await giveDeductionInfo(data)
      this.deductionInfo = res
      this.deductionInfo.unDeductedAmount = res.unDeductedClaims - res.toDeductedAmount
      this.showCreate = true;
      this.clearTableSelection();
    }).catch((err) => {
      console.error(err);
    });
  }

  private async clearClaimInfo() {
    await clearPurchaseOrderClaimInfo(this.id)
        .then(() => {
          this.$notify({
            title: '成功',
            message: '清空索赔成功',
            type: 'success'
          });
          this.getList();
        });
  }

  // 查看回执
  public async handleReceipt(scope) {
    // this.selectedItem = scope.row;
    this.showReceipt = true;
  }

  // 文件管理
  public async handleFile(scope) {
    this.selectedItem = scope.row;
    this.showFile = true;
  }

  private handleSuccess() {
    this.showCreate = false;
    this.showMark = false;
    this.selectedRows = [];
    this.clearTableSelection();
    this.getList();
  }

  //  删除
  public async handleDelete(scope) {
    await removeQuotation({
      detailId: scope.row.approvalRecordId,
    });
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }
  private files: File[] = [];
  private addFile(file: File) {
    this.files.push(file);
    console.log("this.files", this.files);
  }
  private uploadDoc() {
    this.$confirm(
      "上传会删除该采购订单下的所有回执，只保留当前上传的回执",
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    )
      .then(async () => {
        await deleteFile(this.id)
          .then((res) => {
            this.$refs["upload"]["$refs"]["upload-inner"].handleClick();
          })
          .catch((err) => {
            console.log(err);
          });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }
  // 上传回执
  public async uploadReceipt() {
    this.uploadDocLoading = true;
    console.log("上传文件数组3", JSON.stringify(this.files));
    let formData = new FormData();
    formData.append("poId", this.id);
    formData.append("receipt", "true");
    formData.append("files", this.files.pop());
    await uploadInfoFile(formData)
      .then((res) => {
        this.uploadDocLoading = false;
        this.files = [];
        this.$notify({
          title: "成功",
          message: "上传成功",
          type: "success",
          duration: 2000,
        });
      })
      .catch((err) => {
        this.uploadDocLoading = false;
        this.files = [];
      });
    this.getAppendix();
  }
  // public handleReUpload() {
  //   this.$confirm("上传会删除该采购订单下的所有回执，只保留当前上传的回执", "提示", {
  //     confirmButtonText: "确定",
  //     cancelButtonText: "取消",
  //     type: "warning"
  //     })
  //     .then(async () => {
  //       console.log('上传文件数组1',JSON.stringify(this.files))
  //       await deleteFile(this.id).then(res =>{
  //         console.log('上传文件数组2',JSON.stringify(this.files))
  //         this.uploadReceipt();
  //       }).catch(err=>{
  //         console.log(err)
  //       })
  //       this.getList();
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // }

  // public async showCreateSupplierDeductionFun() {
  //   await putSupplierDeduction(this.supplierForm)
  //   this.$notify({
  //     title: "成功",
  //     message: "生成成功",
  //     type: "success",
  //     duration: 2000
  //   });
  //   this.showCreateSupplierDeduction = false
  // }

  private async showCreateSupplierDeductionFun(): Promise<void> {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            if (this.supplierForm.claimReason.length > 0) {
              this.supplierForm.claimReason =
                this.supplierForm.claimReason[
                  this.supplierForm.claimReason.length - 1
                ];
              await putSupplierDeduction(this.supplierForm);
              this.$notify({
                title: "成功",
                message: "生成成功",
                type: "success",
                duration: 2000,
              });
              this.showCreateSupplierDeduction = false;
            }
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }

  // 审批通过
  public async handleAuditPass(scope) {
    this.$confirm("确定审批通过吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditPass(scope.row.approvalRecordId);
        this.$notify({
          title: "成功",
          message: "审批通过",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private handlePI(scope) {
    this.$alert(scope.row.approvalRecordId, "PI号码", {
      confirmButtonText: "复制",
      callback: () => {
        this.h5Copy(scope.row.approvalRecordId);
      },
    });
  }

  // 填写备注
  public async handleRemark(item) {
    try {
      let data = {
        remark: item.remark,
      };
      await poDetailRemark(item.id, data)
        .then((res) => {
          this.$notify({
            title: "成功",
            message: "操作成功",
            type: "success",
            duration: 2000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }
  public async handleRemark2(item) {
    try {
      let data = {
        remark: item.remark,
      };
      await poDetailShippingRemark(item.id, data)
        .then((res) => {
          this.$notify({
            title: "成功",
            message: "操作成功",
            type: "success",
            duration: 2000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }

  public async handleRemark3(item) {
    console.log('handleRemark3',item);
    try {
      let data = {
        remark: item.remark,
      };
      await updateCompanyPriceRemark(item.id, data)
          .then((res) => {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
          })
          .catch((err) => {
            console.log(err);
          });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }

  private h5Copy(content) {
    if (!document.queryCommandSupported("copy")) {
      // 不支持
      return false;
    }
    let textarea = document.createElement("textarea") as any;
    textarea.value = content;
    textarea.readOnly = "readOnly";
    document.body.appendChild(textarea);
    textarea.select(); // 选择对象
    textarea.setSelectionRange(0, content.length); // 核心
    let result = document.execCommand("copy"); // 执行浏览器复制命令
    textarea.remove();
    this.$notify({
      title: "成功",
      message: "复制成功",
      type: "success",
      duration: 2000,
    });
    return result;
  }

  private handleCreateSupplierDeduction() {
    this.showCreateSupplierDeduction = true;
  }

  public handleFilterSearch() {
    this.table.pageNumber = 1;
    this.getList();
  }

  private handleCustomer() {
    // empty
  }

  private linkClick(scope) {
    this.$router.push(`/purchaseOrderDetails?id=${scope.row.id}`);
  }

  public selectedItem = {} as any;

  // 编辑
  public async handleEdit(scope) {
    this.selectedItem = scope.row;
    this.showMark = true;
  }

  public async handleMark(scope) {
    this.selectedItem = scope.row;
    this.showMark = true;
  }

  private handleOrderManage(scope) {
    let item = JSON.stringify(scope.row);
    if (item.indexOf("&") != -1) {
      item = item.replace("&", "replace");
    }
    this.$router.push(`/managePurchaseOrders?id=${scope.row.id}&item=${item}`);
  }

  private async handleInvalidPi(scope) {
    this.$confirm("确定作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await invalidPi(scope.row.id)
          .then((res) => {
            this.confirmSuccess();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async handleUncancelPi(scope) {
    this.$confirm("确定取消作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await uncancelPi(scope.row.id)
          .then((res) => {
            this.confirmSuccess();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  public handleCommand(command) {
    this[command]();
  }

  // 挂起
  private async handleAuditHold(scope) {
    this.$prompt("请输入挂起原因", "挂起", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputType: "textarea",
    })
      .then(async ({ value }: any) => {
        if (!value) {
          this.$message.error("请输入挂起原因");
          return;
        }
        await auditHold({
          id: scope.row.approvalRecordId,
          remark: value,
        });
        this.getList();
      })
      .catch(() => {
        // empty
      });
  }

  private confirmSuccess() {
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 点击是否展示所有产品号码
  private showMore() {
    this.isShowMore = !this.isShowMore;
    this.updateTableMaxHeight();
  }

  private showMore2() {
    this.isShowMore2 = !this.isShowMore2;
    this.updateTableMaxHeight();
  }

  private showMore3() {
    this.isShowMore3 = !this.isShowMore3;
    this.updateTableMaxHeight();
  }

  private toggleActions() {
    this.showActions = !this.showActions;
    this.updateTableMaxHeight();
  }

  private selectedRows = [] as any;

  private onSelectionChange(rows: []) {
    this.selectedRows = rows;
  }
  private async  handlerInputChange({val, row, column }) {
   if (!val){
     const label = column.label;
      this.$notify({
      title: "错误",
      message: "请输入" + label,
      type: "error",
      duration: 2000,
    });
   }
   const data = {
     poInfoId: row.row.id,
     discountPrice : val
   }
    await updateCompanyDiscountPrice(data).then(() => {
      this.$notify({
      title: "成功",
      message: "更新公司定价成功",
      type: "success",
      duration: 2000,
    });
     this.getList();
   })
  }

  private handleOpenContractualDelivery(data) {
    this.contractualDeliveryItem = {
      ...(data || {}),
      id: (data && data.id) || this.id,
    };
    this.showContractualDelivery = true;
  }

  private handleOtherFeeClick(data) {
    this.otherFeeVisible = true;
    this.otherFeeTable.info = {
      purchaseOrderCode: data.poCode,
      productTotalAmount: data.supplierTotalPayment,
      supplier: data.supplierAbbreviation,
    }
    this.otherFeeTable.list = data.purchaseOrderOtherFeeResList;
  }

  // 分配详情
  private handleDistributionDetail(scope) {
    this.otherFeeDetailTable.list = scope.row.distributionDetail;
    this.otherFeeDetailVisible = true;
  }
}
